import handlerFetch from "./fetch"

export const apiMe = async () => {
    return await handlerFetch<Api.Response.User>(
        'user/me/', {}, true
    )
}

